import V from 'voUtils/V.js';
import QuoteTools from 'voUtils/QuoteTools.js';

import {
	doReq
}
from 'voUtils/RestEx.js';
import {
	fireQuote, fireUnitAction, fireCheckout
}
from 'voUtils/TagEx.js';
import {
	find, filter, isEmpty, oneIs
}
from 'voUtils/tools.js';
import DateEx from 'voUtils/DateEx.js';

export default {

	data: {
		bookingData: {
			adults: 2,
			children: 0,
			childrenAges: undefined,
			babys: 0,
			petsCount: 0,
			from: undefined,
			till: undefined
		},
		action: undefined,
		step: undefined, //'booking',
		priceIsUpdated: false,
		showPriceDetails: false,
		quote: {},
		error: undefined,
		preview: undefined,
		summary: undefined,
		selectedImageIndex: undefined,
		showFullDesc: false,
		isBookingScrolled: false,
		scrollToPrice: true,
		maxPets: undefined,
	},
	created: function () {
		this.calListeners = [];
		this.QuoteTools = QuoteTools;

		var params = new URLSearchParams(new URL(window.location).search);
		for (let [k, v] of params) {
			if (oneIs(k, 'ref_adults', 'ref_children', 'ref_babys', 'ref_from', 'ref_till')) {
				this.bookingData[k.substring(4)] = v;
			}
		}

		var hash = window.location.hash;
		if (hash) {
			hash = hash.substring(1);

			let url = new URL(hash, 'https://www.v-office.com');
			let params = new URLSearchParams(url.search);

			for (let p of params) {
				if ((p[0] == 'children' || p[0] == 'babys') && !this.areChildrenWelcome()) {
					//ignore not welcome
				} else if (p[0] == 'petsCount' && !this.arePetsWelcome()) {
					//ignore not welcome
				} else {
					this.bookingData[p[0]] = p[1];
				}
			}
		}


		this.updatePrices();
	},
	mounted: function () {
		this.$nextTick(function () {
			setTimeout(() => {
				this.scrollToPrice = true;
			}, 1500);
		});

		const petsEl = document.querySelector("[data-pets-restriction]");
		if (petsEl) {
			let maxPets = petsEl.getAttribute('data-pets-restriction');
			switch (maxPets) {
			case '0':
				this.maxPets = 1;
				break;
			case '1':
				this.maxPets = 2;
				break;
			case '2':
				this.maxPets = 3;
				break;
			}
		}
	},
	computed: {
		showBookingButtons: function () {
			return this.quote && this.quote.mandatory && !this.priceIsUpdated && isEmpty(this.quote.errors) && !this.action;
		},
		canDoNext: function () {
			return this.quote && this.quote.mandatory && !this.priceIsUpdated && isEmpty(this.quote.errors) && this.action;
		},
		periodLabel: function () {
			let label = '';
			if (this.bookingData.from) {
				label = this.voFormatDate(this.bookingData.from, 'withDay');
			}
			if (this.bookingData.till) {
				label += ' - ' + this.voFormatDate(this.bookingData.till, 'withDay');
			}

			return label;
		},
		guestLabel: function () {
			var sd = this.bookingData;
			var amount = ((sd.adults || 0) - 0) + ((sd.children || 0) - 0) + ((sd.babys || 0) - 0);
			var label = amount + ' ' + this.voMsgPl('guest.pl', amount);
			if (sd.petsCount) {
				label += ', ' + sd.petsCount + ' ' + this.voMsgPl('pet.pl', sd.petsCount);

			}
			return label;
		}


	},
	updated: function () {
		/*$('.fixnavigationbar').affix({
			offset: {
				top: 400
			}
		});*/
		$(".owl-carousel-unit").owlCarousel({
			items: 1,
			loop: true,
			center: true,
			autoplay: false,
			smartSpeed: 1000,
			dots: false,
			nav: true
		});

		$(".owl-carousel-feedback").owlCarousel({
			margin: 5,
			loop: true,
			autoplay: false,
			smartSpeed: 1000,
			dots: false,
			nav: true,
			responsive: {
				0: {
					items: 1
				},
				600: {
					items: 2
				},
				1000: {
					items: 3
				}
			}
		});

	},

	/*watch: {
		'bookingData.till': function () {
			if (this.bookingData.till) {
				console.log('till date is changed....' + this.bookingData.till);
				this.updatePrices();
			}
		}
	},*/

	methods: {
		canAddLine: function (sl, quote) {
			if (sl.service.id === 29914) {
				return false;
			}
			if (sl.service.id === 27019) {
				return false;
			}

			return QuoteTools.canAddLine(sl, quote);

		},
		canRemoveLine: function (sl) {
			var serviceid = sl.service.id;
			if (serviceid === 29914) {
				return false;
			}
			if (serviceid === 27019) {
				return false;
			}
			return QuoteTools.canRemoveLine(sl);
		},
		checkService: function (type, serviceid, optional) {
			//console.log('checkService::', 'type:', type, 'serviceid:', serviceid, 'optional:', optional);
			if (optional === 'true' && (serviceid == 27019 || serviceid == 29914)) {
				//console.log('geblockt:', serviceid);
				return false;
			}

			return true;
		},
		allowGoogleMaps: function () {
			localStorage.setItem('allowGoogleMaps', true);
			location.reload();
		},
		preventGoogleMaps: function () {
			localStorage.setItem('allowGoogleMaps', false);
			location.reload();
		},
		canShowGoogleMaps: function () {
			var GoogleMaps = localStorage.getItem("allowGoogleMaps");
			if (GoogleMaps === 'true') {
				return true;
			}
			return false;
		},
		toggleDescClass: function () {
			this.showFullDesc = !this.showFullDesc;
		},
		getRegionPhoneNumber: function (regionName) {
			if (regionName == 'Kellenhusen') {
				return '+494364-1041';
			} else if (regionName == 'Dahme') {
				return '+494364-8282';
			} else if (regionName == 'Scharbeutz') {
				return '+494503 - 8982525';
			} else {
				return '+494562 - 22 33 00';
			}
		},
		addLine: function (quote, sl) {
			if (sl.service.id === 29914) {
				if (this.bookingData.petsCount >= this.maxPets) {
					VOFFICE.maxAmounts[sl.service.id] = this.maxPets;
					return;
				}
			}
			if (sl.service.id === 27019) {
				if (this.bookingData.petsCount >= this.maxPets) {
					VOFFICE.maxAmounts[sl.service.id] = this.maxPets;
					return;
				}
			}
			QuoteTools.addLine(quote, sl);
			if (sl.service.id === 29914) {
				this.bookingData.petsCount = sl.amount;
			}
			if (sl.service.id === 27019) {
				this.bookingData.petsCount = sl.amount;
			}

			this.$forceUpdate();
		},
		removeLine: function (quote, sl) {
			QuoteTools.removeLine(quote, sl);
			if (sl.service.id === 29914) {
				this.bookingData.petsCount = sl.amount;
			}
			if (sl.service.id === 27019) {
				this.bookingData.petsCount = sl.amount;
			}
			this.$forceUpdate();
		},

		clearPrices: function () {
			this.quote = {};
			this.summary = undefined;
			this.preview = undefined;
			this.previewQuote = undefined;
		},
		updatePrices: function () {
			var data = this.bookingData;
			this.error = undefined;
			if (data.from && data.till) {

				this.priceIsUpdated = true;
				this.quote = {};

				var req = {
					fromdate: DateEx.interfaceFormat(data.from),
					tilldate: DateEx.interfaceFormat(data.till),
					adults: data.adults,
					children: data.children,
					babys: data.babys,
					petsCount: data.petsCount,
					unit: this.getUnitId()
				};

				if (VOFFICE.quoteOptions) {
					Object.assign(req, VOFFICE.quoteOptions);
				}

				if (this.voucher) {
					req.voucherCode = this.voucher.code;
				}

				if (VOFFICE.abtest) {
					req.abtest = VOFFICE.abtest;
				}

				if (data.childrenAges) {
					req.childrenAges = data.childrenAges;
				}

				doReq('quotePrices', req)
					.then((res) => {

						if (req.petsCount > 0) {

							var optionalServices = res.quote.optional;
							var serviceIndex = optionalServices.findIndex(service => service.service.id === 27019 || service.service.id === 29914);

							if (serviceIndex !== -1) {

								var service = optionalServices[serviceIndex];

								//console.log('service:::', service);

								service.amount = req.petsCount;

								// Anpassen des 'total'-Werts
								service.total = service.price * service.amount * service.timespan;

								service.booked = true;

								// Entferne den Service aus dem optionalen Array
								optionalServices.splice(serviceIndex, 1);

								// Füge den angepassten Service dem mandatory Array hinzu
								res.quote.mandatory.push(service);
							}
						}


						this.quote = res.quote;
						this.priceIsUpdated = false;
						this.quote.optional.forEach(sl => {
							sl.optional = true;
							sl.amount = null;
							this.QuoteTools.updateTotal(sl);
						});
						this.quote.onsiteOptional.forEach(sl => {
							sl.onsiteOptional = true;
							sl.amount = null;
							this.QuoteTools.updateTotal(sl);
						});

						if (res.quote.mandatory) {
							this.summary = find(res.quote.mandatory, function (sl) {
								return sl.service.type === 'SUMMARY';
							});

							this.preview = filter(res.quote.mandatory, function (sl) {
								return !VOFFICE.hideTypeOnPricePreview || VOFFICE.hideTypeOnPricePreview.indexOf(sl.service.type) == -1;
							});

							if (!this.preview || this.preview.length < 2) {
								this.preview = undefined;
								this.previewQuote = undefined;
							} else {
								this.previewQuote = {
									mandatory: this.preview,
									hasDiscounts: this.quote.hasDiscounts
								};
							}

						}
						fireQuote(this.getCart());

						//this.addPetServices();

						this.scrollToPriceCalc();
					})
					.catch(e => {
						this.priceIsUpdated = false;
						this.error = e;
					});


			}

		},
		scrollToPriceCalc: function () {
			if (document.getElementById('booking1') || document.getElementById('booking')) {
				if (this.scrollToPrice) {
					this.scrollToPrice = false;
					if ($(window).width() <= 992) {
						setTimeout(function () {
							$('html, body').animate({
								scrollTop: $("#booking1").offset().top - 120
							}, 2000);
						}, 1000);
					}
					if ($(window).width() > 992) {
						setTimeout(function () {
							$('html, body').animate({
								scrollTop: $("#booking").offset().top - 120
							}, 2000);
						}, 1000);
					}
					const thisdata = this;
					setTimeout(function () {
						thisdata.scrollToPrice = true;
					}, 3000);
				}
			}
		},
		getCart: function () {
			return {
				action: this.action,
				quote: this.quote,
				booking: Object.assign({}, this.bookingData),
				unitId: this.getUnitId()
			};
		},

		goAction: function (action) {
			this.action = action;
			this.showPriceDetails = true;
			fireUnitAction(this.getCart());
		},

		putInCart: function () {
			this.step = 'booking';
			fireCheckout(this.getCart());
			window.scrollTo(0, 0);

		},
		cancelBooking: function () {
			this.step = undefined;
		},
		cancel: function () {
			this.action = undefined;
			this.showPriceDetails = false;

		},


		getUnitId: function () {
			if (!this.unitId) {
				let el = document.querySelector("[data-unit-id]");
				if (el) {
					this.unitId = parseInt(el.getAttribute('data-unit-id'), 10);
				}
			}
			return this.unitId;
		},
		areChildrenWelcome: function () {
			if (this.childrenWelcome == undefined) {
				let el = document.querySelector("[data-children-welcome]");
				if (el) {
					this.childrenWelcome = el.getAttribute('data-children-welcome') == '1';
				} else {
					this.childrenWelcome = false;
				}
			}
			return this.childrenWelcome;
		},
		arePetsWelcome: function () {
			if (this.petsWelcome == undefined) {
				let el = document.querySelector("[data-pets-welcome]");
				if (el) {
					this.petsWelcome = el.getAttribute('data-pets-welcome') == '1';
				} else {
					this.petsWelcome = false;
				}
			}
			return this.petsWelcome;
		},
		getMaxValues: function () {
			if (this.maxPets > 0) {
				var object = {
					'petsCount': this.maxPets
				};
				return object;
			}

		},
		getCal: function (done) {
			if (this.cal) {
				done(this.cal);
			} else {
				this.calListeners.push(done);

				if (this.calListeners.length === 1) {

					var req = {
						unit: this.getUnitId()
					};

					doReq('getCal', req)
						.then((res) => {
							this.cal = res.cal;

							for (let l of this.calListeners) {
								l(res.cal);
							}
							this.calListeners.length = 0;

						});
				}
			}


		}
	},
	watch: {
		'bookingData.from': function () {
			if (!this.bookingData.till) {
				this.clearPrices();
			}
		},
		'bookingData.till': function () {

			/*if (!this.isBookingScrolled && this.bookingData.from && this.bookingData.till) {
				this.isBookingScrolled = true;
				if ($(window).width() <= 992) {
					setTimeout(function () {
						$('html, body').animate({
							scrollTop: $("#booking1").offset().top - 120
						}, 2000);
					}, 1000);
				}
				if ($(window).width() > 992) {
					setTimeout(function () {
						$('html, body').animate({
							scrollTop: $("#booking").offset().top - 120
						}, 2000);
					}, 1000);
				}

				const thisdata = this;
				setTimeout(function () {
					thisdata.isBookingScrolled = false;
				}, 3000);
			}*/
		}

	}


};